import React from 'react';
import Button from '../Shared/Button';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../css/Shared/AcceptTermsConditionsModal.css';
import RespModal from '../Shared/RespModal';

function AcceptTermsConditionsModal(props) {
    return(
        <RespModal hasOpen={props.hasOpen}  >
        <div className="acceptTCmodalsize" >
            <div id="acceptTCmodalcontainsuccess">
                 {props.children}
            </div>
            <div class="acceptTCcancelresploginbuttonouter">
        <Button
                id="acceptTCcancelresploginbutton"
                type="button"
                class="btn btn-dark"
                onClick={props.onCloseModal}
            >Accept
        </Button>
            </div>
        </div>
    </RespModal>
    );
}
export default AcceptTermsConditionsModal;